import { SpinnerService } from './../../../../services/shared/spinner.service';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MweConstants } from 'src/app/constants/mwe-constants.service';
import { ListColumn } from 'src/app/models/list-column.model';
import { FormGroup } from '@angular/forms';
import { catchError, map, of, throwError } from 'rxjs';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { OemService } from 'src/app/services/oem/oem.service';
import Swal from 'sweetalert2';
import { LocalStorageService } from 'src/app/services/local-storage.service';
import { DISTRIBUTOR_ID, OEM_ID, ROLE_NAME, USER_ID } from 'src/app/utils/constants';
import { ExhibitionfilterComponent } from '../exhibitionfilter/exhibitionfilter.component';
import { EndCustomerService } from 'src/app/services/end-customer.service';
import { Distributor } from 'src/app/models/distributor-model';
import { Router, ActivatedRoute } from '@angular/router';
import { PermissionService } from 'src/app/services/permission.service';
import { BreadcrumbService } from 'src/app/services/shared/breadcrumb.service';
import { CustomChip } from 'src/app/models/product-model';
import { GeographicalType } from 'src/app/enums/product-enum';
import { SharedService } from 'src/app/services/shared-service.service';
import { SweetAlertService } from 'src/app/services/sweetalert.service';
import { ExportComponent } from '../../distributor/export/export.component';

@Component({
  selector: 'app-exhibitions',
  templateUrl: './exhibitions.component.html',
  styleUrls: ['./exhibitions.component.scss']
})
export class ExhibitionsComponent implements OnInit {
  @Input() selectedData: any;
  @Output() exhibitiondata: any;
  @Output() UpdateExhibibitionid?: string;
  @Output() x: any;
  @Output() oemId: any;

  viewExhibitionId: string = '';
  @Output() backEvent = new EventEmitter<any>();
  @Output() exhibitionid = new EventEmitter<string>();
  @Input() public id!: string;
  Data: any[] = [];
  activeContent: string = 'Exhibitions';
  showAddExhibition: boolean = false;
  exhibitionRegisterForm!: FormGroup;
  exhibitionData: any;
  selectedAccountType: any;
  updateExhibition: boolean = false;
  showExhibition: boolean = false;
  OemService: any;
  userId: any;
  data: any;
  filterObject: any={
    continents:'',
    countries:'',
    states:'',
    cities:'',
    date:'',
    status: '',
    companyName: ''
  };
  showNoRecordsFounds: boolean=false;
  snackbarService: any;
  exhibitionfiltereddata: any;
  showfilterdata: boolean = false;
  distributorId: any;
  appointmentExhibitionId: string='';
  searchKeyword: string = '';
  originalData: any[] = [];
  page:number=0;
  pageSize:number=10;
  keyWord:string='';
  isFiltered: boolean = false;
  permissions=[];
hasAddPermission:boolean=true;
hasViewPermission:boolean=true;
hasEditPermission:boolean=true;
hasDeletePermission:boolean=true;
isPagination: boolean = true;
showPagination: boolean = false;
chips: any[] = [];
clearAllChips: boolean = false;
totalEntries: number = 0;
roleName: string = '';
exhibitionSummary: any = {
  "totalExhibitions": 0,
  "totalUpcoming": 0,
  "totalCompleted": 0,
  "totalAppointments": 0,
  "totalStaffAssigned": 0
}

  fieldsToExport: string[] = ['id','active','content','status','accountType','subject','appointmentCount','city','files','exhibitionStartDate','id','title','staffNames','exhibitionEndDate'];
  close(event: any) {
    this.showAddExhibition = false;
    this.updateExhibition = false;
    this.showExhibition = false;
    this.selectedData = null;
    this.restorePreviousFiltersAndSearch();
    this.getAllExhibitionsByFilter();
  }


  restorePreviousFiltersAndSearch(): void {
    this.route.queryParams.subscribe(params => {
      this.filterObject = {
        continents: params['continents'] || '',
        countries: params['countries'] || '',
        states: params['states'] || '',
        cities: params['cities'] || '',
        date: params['date'] || '',
        status: params['status'] || '',
        companyName: params['companyName'] || ''
      };
  
      this.isFiltered = Object.values(this.filterObject).some(value =>
        (typeof value === 'string' && value.trim() !== '') ||
        (Array.isArray(value) && value.length > 0)
      );
  
      this.searchKeyword = params['search'] || '';
  
      this.getAllExhibitionsByFilter();
    });
  }
  

  onSearch(searchTerm: string) {
    this.applySearchFilter(searchTerm);
  }
  closeToBack(event:any){
    this.showAddExhibition=false;
    this.selectedData=null;
   }
   getExhibitionById(id: string) {
    this.exhibitionService.getExhibitionById(id).subscribe(
      (data) => {
        this.exhibitiondata = data;
      },
      (error) => {
      }
    );
  }
    remove(chip: any): void {
      this.chips = this.chips.filter(c => c !== chip);

      const queryParams: any = {};

      Object.entries(this.filterObject).forEach(([key, value]) => {
        if (
          (typeof value === 'string' && value.trim() !== '') ||
          (Array.isArray(value) && value.length > 0)
        ) {
          queryParams[key] = value;
        }
      });

      const chipKey = chip.type;
      delete queryParams[chipKey];

      if (this.searchKeyword?.trim()) {
        queryParams['search'] = this.searchKeyword.trim();
      }

      this.router.navigate([], {
        relativeTo: this.route,
        queryParams
      });

      this.getAllExhibitionsByFilter();
    }
    

    searchExhibition(event: Event): void {
      const inputElement = event.target as HTMLInputElement;
      const keyword = inputElement.value;
      this.searchKeyword = keyword;
    
      // Store search term in sessionStorage for state persistence
      if (this.searchKeyword) {
        sessionStorage.setItem('oemSearch', this.searchKeyword);
      } else if (this.searchKeyword === "") {
        sessionStorage.removeItem('oemSearch');
      }
    
      this.page = 0;
      
      // Update shared service state
      this.sharedService.setSearchState(keyword, this.page, this.pageSize);
    
      // Prepare query parameters for search
      const queryParams: any = { ...this.route.snapshot.queryParams };
    
      if (this.searchKeyword?.trim()) {
        queryParams['search'] = this.searchKeyword.trim();
      } else {
        delete queryParams['search'];  // Remove search param if empty
      }
    
      // Update URL with search query params
      this.router.navigate([], {
        relativeTo: this.route,
        queryParams
      });
    
      this.getAllExhibitionsByFilter(); // Fetch filtered data
    }
    

      exportExhibitionData() {
        const dialogRef = this.dialog.open(ExportComponent, {
          height:'auto',
          width : 'auto',
          data: {
          title: 'Exhibitions',
          exhibitionId: this.oemId ? this.oemId : ''
          }
        });
        dialogRef.afterClosed().subscribe((result)=>{
          if(result === 'Success'){
            this.sweetAlertService.showSuccess(result,"File downloaded Sucessfully!!");
          }
        });
      }
 
  columns: ListColumn[] = [
    { name: 'Sr.no', property: 'sr_no', visible: true, isModelProperty: false, isText: true },
    { name: 'Appointments', property: 'appointment', visible: true, isModelProperty: true, isSecondaryLink: true, secondaryAction: MweConstants.viewExhibitionsAction},
    { name: 'Exhibition Title', property: 'title', visible: true, isModelProperty: true, isText: true },
    { name: 'Display Date', property: 'displayDate', visible: true, isModelProperty: true, isText: true },
    { name: 'Location', property: 'location', visible: true, isModelProperty: true, isText: true },
    { name: 'Staff Assignment', property: 'staffAssignment', visible: true, isModelProperty: true, isRole: true },
    {name:'id', property: 'id', visible: false, isModelProperty: true, isText: true},
    { name: 'Company Name', property: 'companyName', visible: true, isModelProperty: true, isText: true },
    { name: 'Created By', property: 'createdByName', visible: true, isModelProperty: true, isText: true },
    { name: 'Status', property: 'status', visible: true, isModelProperty: true, isRequestStatus: true },
    {
      name: 'Actions', property: 'action', visible: true, isModelProperty: true, hasAction: true,
      actions: [
        { imageUrl: './../../assets/images/eye-visble.svg', isImage: true, actionType: MweConstants.viewAction },
        { imageUrl: './../../assets/images/edit.svg', isImage: true, actionType: MweConstants.editAction },
        { imageUrl: './../../assets/images/bin.svg', isImage: true, actionType: MweConstants.deleteAction }
      ]
    },
  ] as ListColumn[];

  objects = [
    { id :1, name: "Total Exhibitions", image: "assets/images/icons/OEM_totalRequired.svg", count: 0, code: 'totalExhibitions' },
    { id: 2, name: "Total Upcoming", image: "assets/images/icons/OEM_totalRequired.svg", count: 0, code: 'totalUpcoming' },
    { id: 3, name: "Total Completed", image: "assets/images/icons/OEM_totalIncomplete.svg", count: 0, code: 'totalCompleted' },
    { id: 4, name: "Total Appointments", image: "assets/images/icons/OEM_totalPublished.svg", count: 0, code: 'totalAppointments' },
    { id: 5, name: "Total Staff Assigned", image: "assets/images/icons/OEM_totalHide.svg", count: 0, code: 'totalStaffAssigned' }
  ];

  oemsSummaryDataObjects: any[] = [];

  constructor(
    private dialog: MatDialog,
    private http: HttpClient,
    private endCustomerService: EndCustomerService,
    private exhibitionService: OemService,
    private localStorageService: LocalStorageService,
    private readonly router: Router,
    private readonly route: ActivatedRoute,
    private permissionService: PermissionService,
    private breadcrumbService: BreadcrumbService,
    private sharedService: SharedService,
    private sweetAlertService: SweetAlertService,
    private spinnerService: SpinnerService
  ) {
    this.oemId = this.localStorageService.getItem('roleName') === 'DISTRIBUTOR'
      ? this.localStorageService.getItem(DISTRIBUTOR_ID)
      : (this.localStorageService.getItem('roleName') === 'OEM'
        ? this.localStorageService.getItem(OEM_ID)
        : this.localStorageService.getItem(USER_ID));
    this.roleName = localStorageService.getItem('roleName');
  }
  
  ngOnInit(): void {
    this.spinnerService.showSpinner();
    this.breadcrumbService.setBreadcrumbs(['Dashboard', 'Exhibitions']);
  
    if (this.localStorageService.getItem('preferences')?.length > 0) {
      this.updatePermissions();
    }
  
    this.restorePreviousFiltersAndSearch(); // now fully query param based
  }
  

  updatePermissions(){
    this.permissions=this.localStorageService.getItem('preferences')
    this.hasAddPermission=this.permissionService.hasPermission('EXHIBITION_CREATE',this.permissions);
    this.hasViewPermission=this.permissionService.hasPermission('EXHIBITION_VIEW',this.permissions);
    this.hasEditPermission=this.permissionService.hasPermission('EXHIBITION_EDIT',this.permissions);
    this.hasDeletePermission=this.permissionService.hasPermission('EXHIBITION_DELETE',this.permissions);
    let columns=[
      { name: 'Sr.no', property: 'sr_no', visible: true, isModelProperty: false, isText: true },
      { name: 'Appointments', property: 'appointment', visible: true, isModelProperty: true, isSecondaryLink: true, secondaryAction: MweConstants.viewExhibitionsAction},
      { name: 'Exhibition Title', property: 'title', visible: true, isModelProperty: true, isText: true },
      { name: 'Display Date', property: 'displayDate', visible: true, isModelProperty: true, isText: true },
      { name: 'Location', property: 'location', visible: true, isModelProperty: true, isText: true },
      { name: 'Staff Assignment', property: 'staffAssignment', visible: true, isModelProperty: true, isRole: true },
      {name:'id', property: 'id', visible: false, isModelProperty: true, isText: true},
    ];
    if(this.hasAddPermission &&!this.hasViewPermission &&!this.hasDeletePermission&&!this.hasEditPermission){
      this.columns=columns;
    } else{
    let  action:any= { name: 'Actions', property: 'action', visible: true, isModelProperty: true, hasAction: true,
    actions:[]
      };
      if(this.hasViewPermission){
        action.actions.push({ imageUrl: './../../assets/images/eye-visble.svg', isImage: true, actionType: MweConstants.viewAction });
      }
      if(this.hasEditPermission){
        action.actions.push({ imageUrl: './../../assets/images/edit.svg', isImage: true, actionType: MweConstants.editAction });
      }
      if(this.hasDeletePermission){
        action.actions.push({ imageUrl: './../../assets/images/bin.svg', isImage: true, actionType: MweConstants.deleteAction });
      }

      columns.push(action);
      this.columns=columns;
    }
  }

  getOemDetails() {
    this.exhibitionService.getOEMdetailswithUserId(this.userId).subscribe(data => {
      this.data = data.data;  
    });
  }
  getAllExhibitions() {
    this.exhibitionService.getExhibitions(this.oemId, this.pageSize, this.page, this.keyWord)
      .pipe(
        catchError((error) => {
          return throwError(error);
        })
      ).subscribe((response: any) => {
        this.exhibitionData = response.data;
        this.originalData = [...response.data];
        this.transformData(this.exhibitionData);
        // Apply search if exists
        if (this.searchKeyword) {
          this.applySearchFilter(this.searchKeyword);
        }
      });    
  }
  
  applySearchFilter(searchTerm: string) {
    this.searchKeyword = searchTerm;
    if(this.searchKeyword !== "") {
      sessionStorage.setItem('exhibitionSearch', this.searchKeyword);
    } else if(this.searchKeyword === "" ) {
      sessionStorage.removeItem('exhibitionSearch');
    }
    this.getAllExhibitionsByFilter();
  }

  transformData(transfomedData?: any) {
    const currentDate = new Date();
  
    this.Data = transfomedData.map((item: {
      id: any;
      title: any;
      appointmentCount: any;
      exhibitionStartDate: any;
      exhibitionEndDate: any;
      city: any;
      staffNames: any;
      status: string;
      createdByName: string;
      companyName: string;
    }, index: number) => ({
      sr_no: (index + 1).toString(),
      appointment: item.appointmentCount,
      title: item.title || 'N/A',
      displayDate: `${this.formatDate(new Date(item.exhibitionStartDate))} - ${this.formatDate(new Date(item.exhibitionEndDate))}`,
      exhibitionDate: item.exhibitionStartDate || 'N/A',
      location: item.city || 'N/A',
      staffAssignment: item.staffNames ? item.staffNames.map((name: string) => name.trim()) : ['N/A'],
      action: true,
      id: item.id,
      createdByName: item.createdByName || 'Super Admin',
      companyName: item.companyName || 'Medworld Expo',
      status: item.status,
    }));
  }
  
  formatDate(date: Date): string {
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const day = date.getDate().toString().padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

  selectedAction(event: any) {
    sessionStorage.setItem('exhibitionFilter', JSON.stringify(this.filterObject));
      sessionStorage.setItem('exhibitionSearch', this.searchKeyword);
      sessionStorage.setItem('exhibitionChips', JSON.stringify(this.chips));
    switch (event.action) {
      case MweConstants.addAction:
        this.showAddExhibition = true;
        this.updateExhibition = false;
        this.showExhibition = false;
        break;
      case MweConstants.editAction:
        this.updateExhibition = true;
        this.showAddExhibition = false;
        this.showExhibition = false;
        this.UpdateExhibibitionid=event.row.id;
        break;
      case MweConstants.deleteAction:
        this.deleteExhibition(event);
        break;
      case MweConstants.viewAction:
        this.showExhibition = true;
        this.showAddExhibition = false;
        this.updateExhibition = false;
        this.getExhibitionById(event.row.id);
        this.viewExhibitionId = event.row.id;
        break;
      case MweConstants.filterAction:
        this.openFilter();
        break;
      case MweConstants.filterByDateAction:
        break;
      case MweConstants.viewExhibitionsAction:
        this.appointmentExhibitionId=event.row.id;
        break;
      default:
        break;
    }
  }

  onPageChanged(event: any) {
    this.page = event.pageIndex;
    this.pageSize = event.pageSize;
    this.getAllExhibitionsByFilter();
  }
 
 add(){
    this.showAddExhibition = true;
    this.updateExhibition = false;
    this.showExhibition = false;
 }

  openFilter() {
    const dialogRef = this.dialog.open(ExhibitionfilterComponent, {
      width: 'auto',
      data: [this.filterObject, this.chips],
      disableClose: true,
      autoFocus: false,
    });
    dialogRef.componentInstance.clearFilterData.subscribe((clearFilter: any) => {
      this.filterObject = clearFilter;
      sessionStorage.removeItem('exhibitionFilter');
      this.getAllExhibitionsByFilter(); 
    })

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.filterObject = result[0];
        this.chips = result[1]; // used only in UI
        this.isFiltered = true;
    
        const queryParams: any = {};
    
        // Add only defined and non-empty filters to query params
        Object.entries(this.filterObject).forEach(([key, value]) => {
          if (
            (typeof value === 'string' && value.trim() !== '') ||
            (Array.isArray(value) && value.length > 0)
          ) {
            queryParams[key] = value;
          }
        });
    
        // Optional: if you support search as separate field
        if (this.searchKeyword?.trim()) {
          queryParams['search'] = this.searchKeyword.trim();
        }
    
        this.router.navigate([], {
          relativeTo: this.route,
          queryParams,
        });
    
        this.getAllExhibitionsByFilter();
      } else {
        this.clearAllFilters();
      }
    });
  }

clearAllFilters(): void {
  this.filterObject = {
    continents: '',
    countries: '',
    states: '',
    cities: '',
    date: '',
    status: '',
    companyName: ''
  };

  this.chips = [];
  this.searchKeyword = '';
  this.isFiltered = false;

  this.router.navigate([], {
    relativeTo: this.route,
    queryParams: {} // Remove all filter params
  });

  this.getAllExhibitionsByFilter();
}





  getAllExhibitionsByFilter() {
    const date = this.filterObject?.date;
    if (date) {
      this.filterObject.date = this.FilterformatDate(date);
    }    
    this.exhibitionService.filterExhibitionsWithSearchKeyword((this.roleName === 'SUPER_ADMIN') ? ('') : (this.oemId), this.filterObject, this.pageSize, this.page, this.searchKeyword)
      .subscribe(res => {
        const data = res.data;
        if (data && data.length > 0) {
          this.isPagination = true;
          this.exhibitionData = data;
          this.originalData = [...data];
          this.totalEntries=res.totalCount;
          this.transformData(this.exhibitionData);
          const totalPages = Math.ceil(res.totalCount / this.pageSize);
          if(this.page >= totalPages - 1){
            this.isPagination = false;
          }
          this.showPagination = true;
          this.showNoRecordsFounds = false;
        } else if(!data || data.length === 0 || data === null || data === undefined) {
          this.exhibitionData = [];
          this.originalData = [];
          this.showPagination = false;
          this.transformData(this.exhibitionData);
          this.totalEntries = this.exhibitionData.length;
        }
      }, error => {
        this.exhibitionData = [];
          this.originalData = [];
          this.showPagination = false;
          this.transformData(this.exhibitionData);
      });

      this.exhibitionService.getExhibitionSummary((this.roleName === 'SUPER_ADMIN') ? ('') : (this.oemId), this.searchKeyword, this.filterObject).subscribe((res: any) => {

        this.objects.map((obj: any) => {
          if(obj.code === 'totalExhibitions') {
            obj.count = res?.data.totalExhibitions;
          }
          if(obj.code === 'totalUpcoming') {
            obj.count = res?.data.totalUpcoming;
          }
          if(obj.code === 'totalCompleted') {
            obj.count = res?.data.totalCompleted;
          }
          if(obj.code === 'totalAppointments') {
            obj.count = res?.data.totalAppointments;
          }
          if(obj.code === 'totalStaffAssigned') {
            obj.count = res?.data.totalStaffAssigned;
          }
        })
      })
      this.spinnerService.hideSpinner();
  }
  FilterformatDate(date: any) {
    if (date instanceof Date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    } else {
      return date;
    }
  }


  deleteExhibition(event: any) {
      Swal.fire({
        title: 'Are you sure?',
        text: 'You will not be able to recover the deleted record!',
        iconHtml: '<img src="./assets/images/group-delete.svg">',
        iconColor : 'white',
        showCancelButton: true,
        confirmButtonText: 'Yes, Delete It',
        confirmButtonColor : '#0f74a9',
        cancelButtonText: 'Cancel',  
        cancelButtonColor : '#6c757d'
      }).then((result) => {
        if (result.value) {
        this.deleteExhibitionApi(event);
        } else if (result.dismiss === Swal.DismissReason.cancel) {
          Swal.fire({
            title: 'Cancelled',
            text: 'Item is safe.',
            icon : 'error',
            confirmButtonText: 'Ok',
            confirmButtonColor : '#0f74a9',
          })         
        }
      })    
    }  

    clearSearch(): void {
      this.searchKeyword = '';
      sessionStorage.removeItem('oemSearch');
      this.sharedService.setSearchState('', 0, this.pageSize);
    
      const queryParams: any = { ...this.route.snapshot.queryParams };
    
      if (queryParams['search']) {
        delete queryParams['search'];
      }
    
      this.router.navigate([], {
        relativeTo: this.route,
        queryParams
      });
    
      this.getAllExhibitionsByFilter();
    }
    

    deleteExhibitionApi(event:any){
      this.exhibitionService.executeDeleteRequestURL(event.row.id).subscribe(data=>{
                if(data && data?.data ){
          Swal.fire({
            title: 'Removed!',
            text: 'Item Removed Successfully.',
            iconHtml: '<img src="./assets/images/confirm-btn.svg">',
            iconColor : 'white',
            confirmButtonText: 'Ok',
            confirmButtonColor : '#0f74a9',  
          }).then(result=>{
            this.getAllExhibitionsByFilter();
          })
        }
      },error=>{    
      })
    }}